export const EVENT_DELIVERY_METHOD_VENUE       = 'venue';
export const EVENT_DELIVERY_METHOD_ONLINE      = 'online';
export const EVENT_DELIVERY_METHOD_HYBRID      = 'hybrid';

export const STREAM_CONNECTED_EVENT      = 'stream_connected';
export const STREAM_ACTIVE_EVENT         = 'stream_active';
export const STREAM_DISCONNECTED_EVENT   = 'stream_disconnected';
export const STREAM_IDLE_EVENT           = 'stream_idle';

export const ATTENDEE_SUBSCRIBED_EVENT   = 'pusher:subscription_succeeded';
export const ATTENDEE_ADDED_EVENT        = 'pusher:member_added';
export const ATTENDEE_REMOVED_EVENT      = 'pusher:member_removed';
export const ATTENDEE_EJECTED_EVENT      = 'client-attendee_ejected';

export const MESSAGE_ADDED_EVENT         = 'client-message_added';
export const MESSAGE_REMOVED_EVENT       = 'client-message_removed';
export const MESSAGE_HIGHLIGHTED_EVENT   = 'client-message_highlighted';
export const HOST_HIGHLIGHTED_EVENT      = 'client-host_highlighted';

export const VIDEO_EMOJI_SMILE_EVENT     = 'client-video_emoji_smile';
export const VIDEO_EMOJI_HEART_EVENT     = 'client-video_emoji_heart';
export const VIDEO_EMOJI_THUMBS_UP_EVENT = 'client-video_emoji_thumbs_up';